import { render, staticRenderFns } from "./MemberRegistration.vue?vue&type=template&id=1fff6cad&"
import script from "./MemberRegistrationVue.ts?vue&type=script&lang=ts&"
export * from "./MemberRegistrationVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports